// Helper function to set redux store props on router components
import { connect } from 'react-redux';

function mapStateToProps(state) {
	return state;
}

export default connect(mapStateToProps);



/** WEBPACK FOOTER **
 ** ./frontend/utils/connect.js
 **/